import { CancellablePromise } from '../../app/types/cancellable-promise';
import { MapComponent } from '../../app/components/map/map.component';
type TaskFunc = () => CancellablePromise | void;

export class MapTaskSequencer {
  private queue: TaskFunc[] = [];
  private map: MapComponent;
  private running = false;
  private currentTask: CancellablePromise | null = null;

  constructor(map: MapComponent) {
    this.map = map;
  }

  public AddTask(task: TaskFunc, autoStart = true): this {
    this.queue.push(task);
    if (autoStart && !this.running) {
      this.Start();
    }
    return this;
  }

  public Start(): void {
    if (this.running) return;
    this.running = true;
    this.Next();
  }

  public Abort(): void {
    this.queue = [];
    if (this.currentTask?.abort) {
      this.currentTask.abort();
    }
    this.currentTask = null;
    this.running = false;
  }

  private Next(): void {
    if (this.queue.length === 0) {
      this.running = false;
      return;
    }

    this.WaitForIdle(() => {
      const task = this.queue.shift();
      if (!task) {
        this.running = false;
        return;
      }

      const result = task();

      if (!!result && result?.then) {
        this.currentTask = result;
        result.then(() => {
          this.currentTask = null;
          this.Next();
        }).catch(() => {
          this.currentTask = null;
          this.Next();
        });
      } else {
        this.currentTask = null;
        this.Next();
      }
    });
  }

  private WaitForIdle(callback: () => void): void {
    const mapUI = this.map.SLMap.ui;
    if (mapUI.loaded() && !mapUI.isMoving()) {
      requestAnimationFrame(callback);
    } else {
      mapUI.once('idle', () => requestAnimationFrame(callback));
    }
  }
}
